import { useFrame } from "@react-three/fiber";
import { useScroll } from "@react-three/drei";
import { Vector2, IcosahedronGeometry } from "three";

export default function AutoScroll(props) {
  const scroll = useScroll();

  // MemberSphere를 회전 시킬 방향을 랜덤하게 정함
  const theta = Math.random() * Math.PI * 2;
  const rotationDirection = new Vector2(Math.sin(theta), Math.cos(theta));
  rotationDirection.multiplyScalar(0.002);

  // Icosahedron Geometry의 vertcies를 이용해 위치 후보 생성
  const ico = new IcosahedronGeometry(3.5, 2).attributes.position.array;
  let icoVertices = [];
  for (let j = 0; j < ico.length; j += 3) {
    const p = [ico[j], ico[j + 1], ico[j + 2]];
    if (icoVertices.indexOf(p) === -1) icoVertices.push(p);
  }

  // [설정/자동스크롤]
  const stopThreshold = 0.005;
  const autoScrollSpeed = 0.004; // 스크롤 속도
  const p1 = 0; // 시작 지점
  const p2 = 0.55; // 중간 지점
  const p3 = 1; // 끝 지점
  let prev = 0;
  let trigger = 0;
  let targetScrollOffset = 0.5;
  let lastPosition = 0;
  let deltas = [];

  useFrame(() => {
    deltas.push(scroll.offset - prev);
    if (deltas.length >= 2) {
      deltas.splice(0, 1);
    }

    let flag = true;
    for (let i = 0; i < deltas.length - 1; i++) {
      flag = Math.sign(deltas[i]) == Math.sign(deltas[i + 1]);
      if (!flag) break;
    }
    const delta = deltas.reduce((a, b) => a + b, 0) / deltas.length || 0;

    if (trigger == 0) {
      if (flag) {
        if (delta > 1e-5) {
          trigger = 1;
          targetScrollOffset = scroll.offset > p2 ? p3 : p2;
        } else if (delta < -1e-5) {
          trigger = -1;
          targetScrollOffset = scroll.offset >= p2 ? p2 : p1;
        }
      }
    } else if (trigger == 1) {
      if (targetScrollOffset - scroll.offset > stopThreshold) {
        scroll.offset += autoScrollSpeed * trigger;
        scroll.el.scrollTo({
          top: scroll.offset * window.innerHeight * 8,
        });
      } else {
        scroll.offset = targetScrollOffset;
        scroll.el.scrollTo({
          top: scroll.offset * window.innerHeight * 8,
        });
        lastPosition = targetScrollOffset;
        trigger = 0;
        deltas.push([-1]);
      }
    } else if (trigger == -1) {
      if (scroll.offset - targetScrollOffset > stopThreshold) {
        scroll.offset += autoScrollSpeed * trigger;
        scroll.el.scrollTo({
          top: scroll.offset * window.innerHeight * 8,
        });
      } else {
        scroll.offset = targetScrollOffset;
        scroll.el.scrollTo({
          top: scroll.offset * window.innerHeight * 8,
        });
        trigger = 0;
        lastPosition = targetScrollOffset;
        deltas.push([1]);
      }
    }
    prev = scroll.offset;
  });
}
